import positionCalculatorProvider, {SLOT_TYPE_POSITION_CALCULATOR} from './PositionCalculatorProvider';

import slotOrderFunctionsConfig from './slot-order-functions-config.json';

export default class DefaultSlotArrangementPolicy {
    static getPosition(sportId, groupType, slot) {
        const slotType = slot.type;

        //slotType => order functions
        let orderFunctions = slotOrderFunctionsConfig[sportId][groupType];

        let positionCalculatorTypes = [SLOT_TYPE_POSITION_CALCULATOR];

        if (orderFunctions !== undefined) {
            positionCalculatorTypes = orderFunctions[slotType] || [SLOT_TYPE_POSITION_CALCULATOR];
        }

        const position = [];

        for (let i = 0; i < positionCalculatorTypes.length; i++) {
            const positionCalculator = positionCalculatorProvider(positionCalculatorTypes[i]);

            position.push(positionCalculator(sportId, groupType, slot));
        }

        return position;
    }
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/slot-arrangement-policies/index.js